<mat-card>
<div>
	<b></b>
</div>
<br/>

<mat-card-content>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
	
	<h2>Create Question Bank</h2>
	
	<mat-error *ngIf="globalError"> 
	{{globalError}}
	</mat-error>
	
	<mat-form-field>
	  <mat-select  formControlName="competitionTypeStr"  placeholder="Competition Type"  (selectionChange)="competitionTypeChange($event.value)" required>
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="ct.name" *ngFor="let ct of competitionTypes">{{ct.description}}</mat-option>
	  </mat-select>
	  <mat-error> Please select Competition Type</mat-error>
	</mat-form-field>
	
	<mat-form-field>
	  <!-- <mat-label>Individual Type</mat-label> -->
	  <mat-select formControlName="subjectTypeStr"  placeholder="Subject Type"  required>
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="st.name" *ngFor="let st of subjectTypes">{{ st.description }}</mat-option>
	  </mat-select>
	  <mat-error> Please select Subject</mat-error>
	</mat-form-field>
	
	<mat-form-field [style.display]="'none'">
	  <!-- <mat-label>Individual Type</mat-label> -->
	  <mat-select formControlName="compitionLanguageStr"  placeholder="Competition Language"  required>
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="cl.name" *ngFor="let cl of compitionLanguages">{{ cl.description }}</mat-option>
	  </mat-select>
	  <mat-error> Please select Competition Language</mat-error>
	</mat-form-field>
	
	<mat-form-field>
	  <!-- <mat-label>Individual Type</mat-label> -->
	  <mat-select formControlName="testTypeStr"  placeholder="Test Type"  required>
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="testType.name" *ngFor="let testType of testTypes">{{ testType.description }}</mat-option>
	  </mat-select>
	  <mat-error> Please select Test Type </mat-error>
	</mat-form-field>
</form>
<button mat-raised-button color="primary" [disabled]="!form.valid" *ngIf="!formSubmitAttempt" (click)="onSubmit()">Start</button>
<button mat-button *ngIf="formSubmitAttempt">
	<mat-icon>autorenew</mat-icon>
</button>
<button mat-raised-button color="primary" (click)="clearCompetitionInitData()">Reset</button>


</mat-card-content> </mat-card>